{
  "name": "12-Septimal-Quintal",
  "description": "12-tone 7-Limit Rational Intonation scale, derived from harmonic partial row intervals up to a prime limit of 7. The 7° partial over C produces a harmonic partial row 9th chord over fundamental C: 4:5:6:7:9 and the 5:7 diminished fifth above C produces a more consonant interval than the 5-Limit ratio 32:45. Also, in this scale the 3/4-tone melodic step 25:27, found in the 5-Limit JI scale between 5/3 (A) and 9/5 (B), is replaced with the familiar small semitone 20:21.",
  "scale": ["16/15", "9/8", "6/5", "5/4", "4/3", "7/5", "3/2", "8/5", "5/3", "7/4", "15/8", "2/1"],
  "key_colors_mode": "manual",
  "short_description": "12-JI-7L",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["C", "D", "D", "E", "E", "F", "G", "G", "A", "A", "B", "B"],
  "note_colors": [
    "#ffffff",
    "#dee2da",
    "#ffffff",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#ece6df",
    "#ffffff",
    "#dee2da",
    "#fffae5",
    "#ffe5e5",
    "#fffae5"
  ],
  "equivSteps": 12,
  "fundamental": 260.740741,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
